import {useEffect, useState} from 'react';

import {RedemptionCollection} from '~/types';
import {useRedemptionCodeLookup} from './useRedemptionCodeLookup';

export const RedemptionCodeLookupForm = ({
  findUserData,
  shareRedemptionCode,
}: {
  findUserData: (data: RedemptionCollection) => void;
  shareRedemptionCode: (redemptionCode: string) => void;
}) => {
  const [redemptionCode, setRedemptionCode] = useState('');
  const {
    downloadingUserInfoErrorMsg,
    downloadingUserInfoStatus,
    userData,
    searchUserInfo,
  } = useRedemptionCodeLookup({redemptionCode});

  useEffect(() => {
    if (userData) {
      findUserData(userData);
    }
    if (redemptionCode !== '') {
      shareRedemptionCode(redemptionCode);
    }
  }, [findUserData, redemptionCode, shareRedemptionCode, userData]);
  return (
    <>
      <label
        htmlFor="redemptionCode"
        className="input input-bordered flex items-center gap-2 rounded-[1rem]">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.3332 10.0583C20.2806 9.90591 20.1849 9.77202 20.0577 9.67292C19.9305 9.57381 19.7772 9.51375 19.6166 9.5L14.8749 8.80833L12.7499 4.5C12.6817 4.35911 12.5751 4.24028 12.4425 4.15714C12.3098 4.074 12.1564 4.02991 11.9999 4.02991C11.8434 4.02991 11.69 4.074 11.5573 4.15714C11.4247 4.24028 11.3181 4.35911 11.2499 4.5L9.1249 8.8L4.38323 9.5C4.229 9.52192 4.084 9.58664 3.96469 9.6868C3.84538 9.78696 3.75653 9.91856 3.70823 10.0667C3.66402 10.2114 3.66005 10.3654 3.69676 10.5122C3.73346 10.6591 3.80945 10.7931 3.91657 10.9L7.35823 14.2333L6.5249 18.9667C6.49126 19.1237 6.50369 19.2871 6.56072 19.4372C6.61775 19.5873 6.71693 19.7178 6.84634 19.8128C6.97575 19.9079 7.12988 19.9636 7.29017 19.9731C7.45047 19.9827 7.61012 19.9457 7.7499 19.8667L11.9999 17.6417L16.2499 19.8667C16.3669 19.9326 16.4989 19.9671 16.6332 19.9667C16.8098 19.9673 16.9819 19.9119 17.1249 19.8083C17.2542 19.7157 17.3543 19.588 17.4133 19.4404C17.4724 19.2927 17.488 19.1312 17.4582 18.975L16.6249 14.2417L20.0666 10.9083C20.1869 10.8064 20.2758 10.6724 20.323 10.522C20.3702 10.3715 20.3738 10.2107 20.3332 10.0583ZM15.2082 13.3917C15.1118 13.4853 15.0394 13.601 14.9973 13.7287C14.9553 13.8564 14.9447 13.9923 14.9666 14.125L15.5666 17.625L12.4332 15.9583C12.3115 15.8981 12.1774 15.8668 12.0416 15.8668C11.9057 15.8668 11.7717 15.8981 11.6499 15.9583L8.51657 17.625L9.11657 14.125C9.13843 13.9923 9.12787 13.8564 9.08579 13.7287C9.04371 13.601 8.97135 13.4853 8.8749 13.3917L6.3749 10.8917L9.88323 10.3833C10.0182 10.3646 10.1466 10.313 10.257 10.233C10.3674 10.1531 10.4565 10.0474 10.5166 9.925L11.9999 6.75L13.5666 9.93333C13.6266 10.0557 13.7157 10.1615 13.8262 10.2414C13.9366 10.3213 14.0649 10.3729 14.1999 10.3917L17.7082 10.9L15.2082 13.3917Z"
            fill="#464646"
          />
        </svg>
        <input
          name="redemptionCode"
          required={true}
          placeholder="Redemption code"
          value={redemptionCode}
          onChange={e => setRedemptionCode(e.target.value)}
          style={{minWidth: '300px', textAnchor: 'end'}}
        />
      </label>
      <div className="card-actions pt-3 flex justify-center">
        {downloadingUserInfoStatus === 'none' ? (
          <button
            className="btn btn-primary"
            onClick={() => {
              searchUserInfo();
            }}>
            Search
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="w-4 h-4 opacity-70">
              <path
                fillRule="evenodd"
                d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        ) : downloadingUserInfoStatus === 'requesting' ? (
          <span className="loading loading-spinner loading-sm" />
        ) : downloadingUserInfoStatus === 'success' ? (
          <p className="text-green-600">It's a match!</p>
        ) : downloadingUserInfoStatus === 'error' ? (
          <>
            <p className="text-red-600">Error:</p>
            <p>{downloadingUserInfoErrorMsg}</p>
          </>
        ) : null}
      </div>
    </>
  );
};
